<section class="min-vh-100 overflow-hidden position-relative d-flex align-items-center pt-5 pt-md-0">
  <!-- =========================
       OVERLAY
  ========================== -->
  <div class="position-absolute top-0 start-0 w-100 h-100 z-0 bg-black bg-opacity-25"></div>

  <!-- =========================
       CONTENT
  ========================== -->
  <div class="container-fluid px-3 px-md-4 px-lg-5 position-relative z-1">
    <div class="row align-items-center justify-content-center">

      <!-- LEFT CONTENT -->
      <div class="col-12 col-md-10 col-lg-8 d-flex flex-column justify-content-center align-items-center text-center">

        <h1 class="fw-bold display-5 mb-3 text-hero-section">
          {{ hero_data.headline }}
        </h1>

        <h4 class="text-primary mb-4 fw-light">
          {{ hero_data.sub_headline }}
        </h4>

        <div class="d-flex gap-3 align-items-center justify-content-center mb-3 mb-md-4 mb-lg-5">
          <router-link
            to="/login"
            class="btn btn-primary btn-sm px-4 py-2 fw-light text-xs text-decoration-none"
          >
            {{ hero_data.btn_text }}
          </router-link>
        </div>

        <!-- =========================
             CARDS START
             - Mobile: 1 per row
             - Tablet + Small Laptops: 2 per row
             - Large screens (xl+): 4 per row
        ========================== -->
        <div class="container-fluid px-0 mt-3 mt-md-2 mt-lg-2 mt-xl-4">
          <div class="row g-3 g-md-4 row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-2 row-cols-xl-4">

            <div class="col" v-for="card in hero_cards" :key="card.key">
              <div class="glass-card p-4 text-center h-100 rounded-3">

                <!-- SPECIAL CASE: Energy + Water in ONE card -->
                <template v-if="card.key === 'energy'">
                  <div class="d-flex align-items-center justify-content-between gap-3">

                    <!-- WATER -->
                    <div class="flex-fill text-center">
                      <div class="mb-2">
                        <i class="bi bi-droplet-fill fs-2 text-primary"></i>
                      </div>
                      <div class="fw-normal text-white">Water</div>
                    </div>

                    <!-- VERTICAL DIVIDER -->
                    <div class="vr opacity-50"></div>

                    <!-- ENERGY -->
                    <div class="flex-fill text-center">
                      <div class="mb-2">
                        <i class="bi bi-lightning-charge-fill fs-2 text-primary"></i>
                      </div>
                      <div class="fw-normal text-white">Energy</div>
                    </div>
                  </div>
                </template>

                <!-- NORMAL CARDS -->
                <template v-else>
                  <div class="mb-3">
                    <img v-if="card.logo" :src="card.logo" class="card-icon" />
                    <i v-else :class="card.icon + ' fs-2 text-primary'"></i>
                  </div>

                  <h5 class="fw-normal text-white mb-1">
                    {{ card.label }}
                  </h5>

                  <p class="small text-muted mb-0">
                    {{ card.description }}
                  </p>
                </template>

              </div>
            </div>

          </div>
        </div>
        <!-- CARDS END -->

      </div>
    </div>
  </div>
</section>
